import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import MaterialIcon from "components/common/MaterialIcon";
import { Input } from "antd";

@autobind
/**
 *
 */
export default class Email extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    return (
      <Input
        prefix={<MaterialIcon name="email" />}
        type="email"
        dir="auto"
      />
    );
  }
}
